export enum GlobalErrorAction {
  THROW_GLOBAL_ERROR = 'THROW_GLOBAL_ERROR'
}

export const throwGlobalError = () => ({
  type: GlobalErrorAction.THROW_GLOBAL_ERROR
});
